var $class="se2--content-article-slide-carousel-background",$name="ContentArticleSlideCarouselBackground",$path="app/components/ContentArticleSlideCarouselBackground/config.js",$this={$class,$name,$path,};export const slidesSelector = '.article-slides';
export const controlsSelector = '.controls';
export const prevButtonSelector = '.slider-button-prev';
export const nextButtonSelector = '.slider-button-next';
export const activeSlideClassName = 'active-slide';
export const articleSlideContainerSelector = '.article-slide-carousel-container';
export const videoBlockSelector = '.video-thumbnail';
export const thumbnailImageSelector = '.thumbnail-image img';
export const titleSelector = '.title';
export const infoBlockContainerSelector = '.info-block-container';
export const paginationBulletClassName = 'pagination-bullet';
export const slideLinkSelector = '.slide-link';
export const interactiveElementsSelector = 'a, .se-rich-text a, button, iframe';
